import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { FDSecondaryActionIconButton, FDStack, FDTooltip } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Spacer from 'Components/UI/Spacer';
import {
  getStyleFromCellType,
} from './TableRowCell';

const styles = () => ({
  root: {
    width: '200px',
    position: 'sticky',
    left: 0,
  },
  primaryRowLabel: {},
  clickablePrimaryRowLabel: {
    cursor: 'pointer',
  },
  subLabel: {
    fontWeight: 400,
  },
});

const TableRowLabel = ({
  label,
  altLabel,
  subLabel,
  isRowSet,
  className,
  classes,
  cellType,
  rowDetailsUrl,
  rowLocked,
  rowResource,
  onLockRow,
  test,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const onEdit = useCallback(() => {
    return loadModalCollectionByLink(rowDetailsUrl);
  }, [loadModalCollectionByLink, rowDetailsUrl]);

  const { color } = getStyleFromCellType(cellType);
  return (
    <div className={classNames(classes.root, className)}>
      <FDStack direction={'row'} alignItems={'center'}>
        {onLockRow && (
        <FDSecondaryActionIconButton
          label={'Lock/Unlock the values of each cell in the row'}
          icon={rowLocked ? 'lock' : 'lockOpen'}
          onClick={() => onLockRow(rowResource)}
          size={'sm'}
        />
        )}
        <Spacer />
        <FDTooltip title={altLabel || ''} placement="top">
          <Typography
            className={classNames({
              [classes.primaryRowLabel]: !isRowSet,
              [classes.clickablePrimaryRowLabel]: !!onEdit,
            })}
            color={color || !isRowSet ? 'primary' : 'primaryGray'}
            weight={'medium'}
            align={'right'}
            onClick={onEdit || null}
            test={test}
          >
            {label}
          </Typography>
        </FDTooltip>
        <Typography
          variant={'body1'}
          align={'right'}
          className={classes.subLabel}
        >
          {subLabel}
        </Typography>
      </FDStack>
    </div>
  );
};

TableRowLabel.defaultProps = {
  className: '',
  label: '',
  altLabel: null,
  subLabel: '',
  isRowSet: false,
  cellType: null,
  rowDetailsUrl: null,
  rowLocked: false,
  onLockRow: null,
  rowResource: null,
  test: '',
};

TableRowLabel.propTypes = {
  label: PropTypes.string,
  altLabel: PropTypes.string,
  subLabel: PropTypes.string,
  isRowSet: PropTypes.bool,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  cellType: PropTypes.string,
  rowDetailsUrl: PropTypes.string,
  rowLocked: PropTypes.bool,
  onLockRow: PropTypes.func,
  rowResource: PropTypes.object,
  test: PropTypes.string,
};

export default withStyles(styles)(TableRowLabel);
